/**
 * PasoProblemas — Paso 4 del IE. Array de problemas; cada uno con UNA
 * recomendación (1:1). Pares de textarea descripción/recomendación.
 */
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/shared/ui/button.js";
import type { IeProblema } from "../../types.js";
import { LabeledTextarea, labelClass } from "./fields.js";

export function PasoProblemas(props: {
  value: IeProblema[];
  onChange: (next: IeProblema[]) => void;
  disabled?: boolean;
}) {
  const { value, onChange, disabled } = props;

  function agregar() {
    onChange([...value, { descripcion: "", recomendacion: "" }]);
  }

  function quitar(index: number) {
    onChange(value.filter((_, i) => i !== index));
  }

  function set(index: number, key: keyof IeProblema, v: string) {
    onChange(value.map((p, i) => (i === index ? { ...p, [key]: v } : p)));
  }

  return (
    <div className="space-y-4">
      {value.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          Sin problemas registrados. Agrega el primero con el botón de abajo.
        </p>
      ) : (
        <ul className="space-y-4">
          {value.map((problema, i) => (
            <li key={i} className="space-y-3 rounded-lg border border-border bg-background/60 p-4">
              <div className="flex items-center justify-between">
                <span className={labelClass}>Problema {i + 1}</span>
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  disabled={disabled}
                  onClick={() => quitar(i)}
                  className="gap-1.5 font-mono text-[0.625rem] uppercase tracking-[0.1em] text-destructive"
                >
                  <Trash2 className="size-3.5" aria-hidden />
                  Quitar
                </Button>
              </div>
              <LabeledTextarea
                id={`prob-${i}-descripcion`}
                label="Descripción"
                value={problema.descripcion}
                onChange={(v) => set(i, "descripcion", v)}
                disabled={disabled}
              />
              <LabeledTextarea
                id={`prob-${i}-recomendacion`}
                label="Recomendación"
                value={problema.recomendacion}
                onChange={(v) => set(i, "recomendacion", v)}
                disabled={disabled}
              />
            </li>
          ))}
        </ul>
      )}

      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={disabled}
        onClick={agregar}
        className="gap-1.5 font-mono text-[0.625rem] uppercase tracking-[0.12em]"
      >
        <Plus className="size-3.5" aria-hidden />
        Agregar problema
      </Button>
    </div>
  );
}
